"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaffType = exports.DateFormat = exports.PayFrequency = exports.ProcessingPeriod = exports.Timer = exports.Withholdings = exports.PaymentMethod = exports.ContractorTypes = exports.EmploymentTypes = exports.ContractorType = exports.EmployeeType = exports.PayTypeLabels = exports.PayTypes = exports.PayerType = exports.PayrollActionState = exports.PayrollStatus = exports.PayrollTypes = exports.UserPreference = void 0;
exports.UserPreference = Object.freeze({
    SHOW_ANNUAL_AS_HOURLY: 'SHOW_ANNUAL_AS_HOURLY',
});
exports.PayrollTypes = Object.freeze({
    REGULAR: 'REGULAR',
    OFF_CYCLE: 'OFF_CYCLE',
});
exports.PayrollStatus = Object.freeze({
    DRAFT: 'DRAFT',
    INITIAL: 'INITIAL',
    PAID: 'PAID',
    PARTIALLY_PAID: 'PARTIALLY_PAID',
    PENDING: 'PENDING',
    PROCESSING: 'PROCESSING',
    FAILED: 'FAILED',
});
exports.PayrollActionState = Object.freeze({
    ...exports.PayrollStatus,
    DUE_SOON: 'DUE_SOON',
    MISSED_DIRECT_DEPOSIT: 'MISSED_DIRECT_DEPOSIT',
    OVERDUE: 'OVERDUE',
    MANUAL_CHECKS: 'MANUAL_CHECKS',
});
exports.PayerType = Object.freeze({
    COMPANY: 'COMPANY',
    EMPLOYEE: 'EMPLOYEE',
});
exports.PayTypes = Object.freeze({
    HOURLY: 'HOURLY',
    SALARY: 'SALARY',
    CONTRACT: 'CONTRACT',
    CONTRACTOR: 'CONTRACTOR',
});
exports.PayTypeLabels = Object.freeze({
    HOURLY: 'Hourly',
    SALARY: 'Salary',
});
exports.EmployeeType = Object.freeze({
    FULLTIME: 'fulltime',
    PARTTIME: 'parttime',
});
exports.ContractorType = Object.freeze({
    INDIVIDUAL: 'individual',
    BUSINESS: 'business',
});
exports.EmploymentTypes = Object.freeze({
    CONTRACTOR: 'Contractor',
    FULL_TIME: 'Full Time',
    PART_TIME: 'Part Time',
});
exports.ContractorTypes = Object.freeze({
    INDIVIDUAL: 'INDIVIDUAL',
    BUSINESS: 'BUSINESS',
});
exports.PaymentMethod = Object.freeze({
    MANUAL: Object.freeze({
        label: 'Manual Check',
        value: 'MANUAL',
    }),
    DIRECT_DEPOSIT: Object.freeze({
        label: 'Direct Deposit',
        value: 'DIRECT_DEPOSIT',
    }),
});
exports.Withholdings = Object.freeze({
    FORCE_SUPPLEMENTAL_WITHHOLDING: 'FORCE_SUPPLEMENTAL_WITHHOLDING',
    APPLY_BENEFITS: 'APPLY_BENEFITS',
    APPLY_POST_TAX_DEDUCTIONS: 'APPLY_POST_TAX_DEDUCTIONS',
});
exports.Timer = Object.freeze({
    SHORT: 1000,
    MEDIUM: 3000,
    LONG: 5000,
    XLONG: 10000,
});
exports.ProcessingPeriod = Object.freeze({
    FOUR_DAY: 'FOUR_DAY',
    TWO_DAY: 'TWO_DAY',
});
exports.PayFrequency = Object.freeze({
    WEEKLY: {
        label: 'Weekly',
        value: 'WEEKLY',
    },
    BIWEEKLY: {
        label: 'Every other week (Biweekly)',
        value: 'BIWEEKLY',
    },
    SEMIMONTHLY: {
        label: 'Twice per month (Semimonthly)',
        value: 'SEMIMONTHLY',
    },
});
exports.DateFormat = Object.freeze({
    MM_DD_YYYY: 'MM/dd/yyyy',
    WD_MM_DD_YYYY: 'E MM/dd/yyyy',
    YYYY_MM_DD: 'yyyy-MM-dd',
});
exports.StaffType = Object.freeze({
    EMPLOYEE: 'EMPLOYEE',
    CONTRACTOR: 'CONTRACTOR',
});
//# sourceMappingURL=payroll.js.map